<template>
    <div v-if="can('routes.index')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n("Transportation organization")}}</a></router-link>
                <router-link to="/routes" tag="li" class="breadcrumb-item"><a href="">{{i18n('Routes')}}ы</a></router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <h1 class="title">{{i18n("Routes")}}</h1>
            </div>
            <div class="base_box_cnt">
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-12">
                        <div class="button-group" v-if="can('routes.create')">
                            <router-link to="/routes/create" class="btn base_btn solid_blue waves-effect waves-light">{{i18n('Create')}}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_cnt pb-0 form-inline">
            <div class="form-inline mr-5">
                <label class="col-form-label fs-12 mr-3" for="from">{{i18n("Point of departure")}}:</label>
                <input type="text" class="form-control" id="from" @keyup="filterSchedules" v-model="from">
            </div>
            <div class="form-inline">
                <label class="col-form-label fs-12 mr-3" for="to">{{i18n("Destination")}}:</label>
                <input type="text" class="form-control" id="to" @keyup="filterSchedules" v-model="to">
            </div>
        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col">
                                    <button class="w-100 text-left" type="button">{{i18n("Name")}} <span class="float-right d-none"><i class="mdi mdi-arrow-up"></i></span></button>
                                </th>
                                <th scope="col">{{i18n("Km")}}</th>
                                <th scope="col">{{i18n("Bus terminal")}}</th>
                                <!--<th scope="col">Комментарий</th>-->
                                <th scope="col" class="last-th"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="route in routes">
                                <td>{{route.name}}</td>
                                <td>{{route.distance}}</td>
                                <td>{{route.routes_stations.length}}</td>
                                <td class="text-center">
                                    <router-link v-if="can('routes.edit')" :to="'/routes/update/' + route.id " class="btn-icon">
                                        <i class="mdi mdi-pencil text-primary"></i>
                                    </router-link>
                                    <button v-if="can('routes.delete')" type="button" class="btn-icon" @click="deleteItem(route)">
                                        <i class="mdi mdi-minus-circle text-danger"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <pagination :links="links" :url="'routes'"></pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "../../components/Pagination";

    export default {
        components: {Pagination},
        data() {
            return {
                routes: [],
                routesFilter: [],
                from: '',
                to: '',
                links: {},
                page: 1
            }
        },
        created() {
            this.loadRoutes();
        },
        methods: {
            loadRoutes() {
                this.$api.get('routes.index', {
                    page: this.page,
                    from: this.from,
                    to: this.to
                })
                    .then(res => {
                        this.routes = res.data;
                        this.links = res.links;
                        // this.filterSchedules(false);
                    });
            },
            filterSchedules() {
                this.page = 1;
                this.loadRoutes()
            },
            deleteItem(item) {
                if (confirm('Вы действительно хотите удалить этот маршрут?')) {
                    this.$api.delete('routes.delete', item.id)
                        .then(res => {
                            if (!res.errors) {
                                let indx = this.routesFilter.indexOf(item);
                                this.routesFilter.splice(indx, 1);
                                this.$store.commit('successNotify');
								this.loadRoutes();
							}
                        })
                }
            }
        },
        beforeRouteUpdate(to, from, next) {
            let page = to.params.page;
            if (page) {
                this.page = page;
                this.loadRoutes();
            }
            next();
        },
        mounted() {
            $('.selectpicker').selectpicker();
        }
    }
</script>

<style></style>
